import 'proxy-polyfill/proxy.min.js';
export class JWebWeb {
    constructor() {
        this.platform = 'web';
        this.isNative = false;
        // Need to assign here to avoid having to define every plugin but still
        // get the typed benefits of the provided plugins in PluginRegistry
        this.Plugins = {};
        // Build a proxy for the Plugins object that returns the "Noop Plugin"
        // if a plugin isn't available
        this.Plugins = new Proxy(this.Plugins, {
            get: (target, prop) => {
                if (typeof target[prop] === 'undefined') {
                    const thisRef = this;
                    return new Proxy({}, {
                        get: (_target, _prop) => {
                            if (typeof _target[_prop] === 'undefined') {
                                return thisRef.pluginMethodNoop.bind(thisRef, _target, _prop, prop);
                            }
                            else {
                                return _target[_prop];
                            }
                        }
                    });
                }
                else {
                    return target[prop];
                }
            }
        });
    }
    pluginMethodNoop(_target, _prop, pluginName) {
        return Promise.reject(`${pluginName} does not have web implementation.`);
    }
    getPlatform() {
        return this.platform;
    }
    isPluginAvailable(name) {
        return this.Plugins.hasOwnProperty(name);
    }
    convertFileSrc(filePath) {
        return filePath;
    }
    handleError(e) {
        console.error(e);
    }
    createLogger(options) {
        return Promise.reject(`createLogger with options=${options} does not have web implementation.`);
    }
}
//# sourceMappingURL=web-runtime.js.map